"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BuilderContainerModule = /** @class */ (function () {
    function BuilderContainerModule() {
    }
    return BuilderContainerModule;
}());
exports.BuilderContainerModule = BuilderContainerModule;
